// Public surface of the submit-queue feature (Instance B, submit-queue sprint).
//
// The registry imports the default (the page) and `queueIcon` for its one entry.
// Other screens import the button, one line each:
//
//   import { SubmitToQueueButton } from '../features/queue';
//   <SubmitToQueueButton practiceId={practiceId} claim={claim} />
//
// The button gates itself on `features.submit_queue` and the claim's status, so it
// is safe to mount unconditionally.

import React from "react";

export { default } from "./QueuePage";
export { default as QueuePage } from "./QueuePage";
export { default as SubmitToQueueButton } from "./SubmitToQueueButton";
export { default as SubmissionCard } from "./SubmissionCard";
export { default as CoveragePage, coverageIcon } from "./CoveragePage";
export { default as SignInBanner } from "./SignInBanner";
export {
  default as usePmsGates,
  invalidatePmsGates,
  primePmsGates,
} from "./usePmsGates";

export const feature = "submit_queue";

export const queueIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M22 2L11 13" />
    <path d="M22 2l-7 20-4-9-9-4 20-7z" />
  </svg>
);
